// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2I7-I","signatureButtonsRight":"ModalSign_signatureButtonsRight__1K-tz"};